import { render, staticRenderFns } from "./CourseChoose.vue?vue&type=template&id=4a033306&"
import script from "./CourseChoose.vue?vue&type=script&lang=js&"
export * from "./CourseChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports